// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609171004/js/" + chunkId + "." + {"44":"98bb7833","225":"a5d8ae76","481":"06770a3a","486":"ad342040","770":"6e7f98fd"}[chunkId] + ".0.7181802730198027.chunk.js";
};